import React from 'react';

export const DashboardInboxMessagesBlankState = () => (
  <div className='max-w-[640px]'>
    <p className='text-bedrock-p text-bedrock-black'>
      Your inbox keeps you up-to-date on conversations in your Journeys. Once you’ve received a comment we’ll start
      listing them here.
    </p>
  </div>
);
